import { InputBox } from '@imprivata-cloud/components';
import { Form } from 'antd';
import { useTranslation } from 'react-i18next';
import { getAadConsentUrl } from '../../../api/setupServices';
import ContinueButton from '../../../components/continueButton/ContinueButton';

const TRANSLATION_ROOT = 'setup.connect-entraid.content';

type FormValues = { 'Entra Id': string };

// DRAFT - FUTURE - Not used
const ConnectEntraId = () => {
  const { t } = useTranslation();

  const [form] = Form.useForm<FormValues>();

  const onSubmit = async (values: FormValues) => {
    try {
      const { aadConsentUrl } = await getAadConsentUrl({ aadTenantId: values['Entra Id'] });
      // going off Impr domain, might want to persist state
      const parsed = new URL(aadConsentUrl);
      const allowedHosts = ['login.microsoftonline.com', 'login.microsoft.com', 'login.windows.net'];
      if (parsed.protocol === 'https:' && allowedHosts.includes(parsed.hostname)) {
        // deepcode ignore OR: aadConsentUrl is validated against an explicit HTTPS + Microsoft hostname allowlist before the redirect.
        window.location.href = aadConsentUrl;
      }
    } catch (e) {
      console.error('[TODO][ErrorBanner]', e);
      alert('Wrong Tenant Id');
    }
  };

  return (
    <>
      <p>{t(`${TRANSLATION_ROOT}.entraid-find-instructions`)}</p>
      <Form form={form} onFinish={onSubmit}>
        <Form.Item name="Entra Id" rules={[{ required: true }]}>
          <InputBox label={t(`${TRANSLATION_ROOT}.entraid-label`)} required autoFocus />
        </Form.Item>
        <ContinueButton
          validateDirty
          htmlType="submit"
          label={t(`${TRANSLATION_ROOT}.next-button`)}
        />
      </Form>
      <p>{t(`${TRANSLATION_ROOT}.privilege-instructions`)}</p>
    </>
  );
};

export default ConnectEntraId;
